import { RequestService } from "../../../../../common/services/RequestService";
import { GET_FILTER_VEHICLES } from "../../constants";
import {
  dataAdjustmentResponse,
  dataAdjustmentFiltersRequest
} from "./dataAdjustment";

export const getFilterVehiclesRequest = async (profileId, filters) => {
  const response = await RequestService.get(
    GET_FILTER_VEHICLES.replace("{profile_id}", profileId),
    {
      params: dataAdjustmentFiltersRequest(filters)
    }
  );

  console.log(response.data);

  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(vehicle => dataAdjustmentResponse(vehicle))
  );
};
